module.exports = __webpack_public_path__ + "img/antes_despues_13.96aeb7b1.png";